import { handleActions, createAction } from 'redux-actions';
import { cloneDeep, get } from 'lodash';

export const TOGGLE_MENU = createAction('TOGGLE/MENU');
export const SET_IS_MOBILE = createAction('SET_IS_MOBILE');

const initialState = {
  isMenuOpened: false,
  isMobile: null,
};

const Layout = handleActions(
  {
    [TOGGLE_MENU]: (state) => {
      const newState = cloneDeep(state);
      newState.isMenuOpened = !get(state, 'isMenuOpened');
      return newState;
    },
    [SET_IS_MOBILE]: (state, { payload, }) => {
      const newState = cloneDeep(state);
      newState.isMobile = payload;
      return newState;
    },
  },
  initialState
);

export default Layout;
